// extracted by mini-css-extract-plugin
export default {"page":"DiagnosisResult_page__semfZ","container":"DiagnosisResult_container__9rL91","viewBtn":"DiagnosisResult_viewBtn__x0hDq","resultCard":"DiagnosisResult_resultCard__p0Ahz"};